import { required } from '@vuelidate/validators'

import { DateTimeUtil } from '@shared/utils/DateTime'
import { ValidatorsUtil } from '@shared/utils/Validators'
import { dateOfBirth } from '@shared/validations/components'
import { GENDER } from '@shared/config/constants'

export default {
  address: {
    zipCode: required,
    location: ValidatorsUtil.isLocation,
  },
  dateOfBirth: {
    ...dateOfBirth,
    dateRange: function (value, model) {
      return model.gender !== GENDER.UNBORN || DateTimeUtil.isInFuture(value)
    }
  },
  gender: {
    required,
  },
}
